import { render, staticRenderFns } from "./PopupRiskInfoEp1_3x3.vue?vue&type=template&id=212f6d76&scoped=true"
import script from "./PopupRiskInfoEp1_3x3.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfoEp1_3x3.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfoEp1_3x3.vue?vue&type=style&index=0&id=212f6d76&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfoEp1_3x3.vue?vue&type=style&index=1&id=212f6d76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f6d76",
  null
  
)

export default component.exports